import { createMuiTheme, useMediaQuery } from "@material-ui/core"; 

const theme = createMuiTheme();
const mobileBreakpoint = theme.breakpoints.values.sm;
const tabletBreakpoint = theme.breakpoints.values.md;
const desktopBreakpoint = theme.breakpoints.values.lg;

export default function useViewport(noSsr?: boolean) {

    const isMobileOrSmaller = useMediaQuery(`(max-width: ${mobileBreakpoint}px)`, { noSsr });
    const isMobileOrLarger = useMediaQuery(`(min-width: ${mobileBreakpoint}px)`, { noSsr });
    const isTabletOrSmaller = useMediaQuery(`(max-width: ${tabletBreakpoint}px)`, { noSsr });
    const isTabletOrLarger = useMediaQuery(`(min-width: ${tabletBreakpoint}px)`, { noSsr });
    const isDesktopOrSmaller = useMediaQuery(`(max-width: ${desktopBreakpoint}px)`, { noSsr });
    const isDesktopOrLarger = useMediaQuery(`(min-width: ${desktopBreakpoint}px)`, { noSsr });

    return {
      isMobileOrSmaller,
      isMobileOrLarger,
      isTabletOrSmaller,
      isTabletOrLarger,
      isDesktopOrSmaller,
      isDesktopOrLarger
    };
}